<template>
    <Vuetable
        :fields="fields"
        :api-mode="false"
        :data="documents"
    >

    </Vuetable>
</template>

<script>
import Vuetable from 'vuetable-2/src/components/Vuetable';
import Vue from 'vue';
import ColumnSector from '@components/Documents/Conferences/Columns/ColumnSector.vue';
import ColumnFlag from '@components/Documents/Conferences/Columns/ColumnFlag.vue';
Vue.component('column-sector', ColumnSector);
Vue.component('column-flag', ColumnFlag);

export default {
    name: "ListStandoutDocuments",
    components: {
        Vuetable
    },
    props: {
        documents: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            fields: [
                {
                    name: 'date',
                    sortField: 'date',
                    title: 'Date',
                    width: '100px',
                    dataClass: 'data-label data-date'
                },
                {
                    name: 'client',
                    sortField: 'client',
                    title: 'Client',
                    width: '150px',
                    dataClass: 'data-label data-client'
                },
                {
                    name: "counterpart",
                    sortField: "counterpart",
                    title: "Counterpart",
                    width: '150px',
                    dataClass: 'data-label data-counterpart'
                },
                {
                    name: '__component:column-sector',
                    sortField: "sector",
                    title: 'Sector',
                    width: '200px',
                    dataClass: 'data-sector'
                },
                {
                    name: "comments",
                    title: "Comments",
                    width: "200px",
                    dataClass: "data-label data-comments"
                },
                {
                    name: 'deal_type',
                    sortField: 'deal_type',
                    title: 'Deal Type',
                    width: '100px',
                    dataClass: 'data-label deal-type'
                },
                {
                    name: "__component:column-flag",
                    title: "Country",
                    width: "80px",
                    dataClass: "data-label data-country"
                },
                {
                    name: "implied_ev",
                    title: "Implied EV ($m)",
                    width: "130px",
                    dataClass: "data-label data-value"
                },
            ]
        }
    }
}
</script>

<style scoped lang="scss">

</style>
